const ACCESS_TOKEN_KEY = 'accessToken'
const TENANT_ID_KEY = 'tenantId'

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token) {
  return localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function removeAccessToken() {
  return localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function getTenantId() {
  return localStorage.getItem(TENANT_ID_KEY)
}

export function setTenantId(tenantId) {
  return localStorage.setItem(TENANT_ID_KEY, tenantId)
}

export function removeTenantId() {
  return localStorage.removeItem(TENANT_ID_KEY)
}
